export const FORETHOUGHT_API_KEY = "d36401a7-be8c-4a25-b876-cfc89d5b1def";
export const FORETHOUGHT_SCRIPT_URL =
  "https://solve-widget.forethought.ai/embed.js";
export const FORETHOUGHT_SCRIPT_ID = "forethought-widget-embed-script";
